<template>
  <div class="col-12 bg-primary text-center  text-white p-2">
    <h5>{{ titulo }}</h5>
    <p class="">{{ subtitulo }}</p>
  </div>
</template>

<script>
export default {
  props: ["titulo", "subtitulo"],
};
</script>

<style></style>
